import { render, staticRenderFns } from "./contractFeeNewList.vue?vue&type=template&id=9f056734&scoped=true"
import script from "./contractFeeNewList.vue?vue&type=script&lang=js"
export * from "./contractFeeNewList.vue?vue&type=script&lang=js"
import style0 from "./contractFeeNewList.vue?vue&type=style&index=0&id=9f056734&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f056734",
  null
  
)

export default component.exports